import { IOnlineUsersResponse } from '@/models/website/OnlineUsersResponse';
import { ISignalRMemberCounter } from '@/models/website/SignalRMemberCounter';
import { IWebsiteClient } from '@/models/website/WebsiteClient';
import { StatisticsApi } from '@/services/api/api.statistics';
import store from '@/store';
import { UserStatisticsViewModel, TopHKViewObject, TopVotersViewModel, TopHKRequest } from '@/types/apiServerContract';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';

@Module({ namespaced: true, dynamic: true, store, name: 'StatisticsModule' })
class StatisticsState extends VuexModule {
	userStatistics: UserStatisticsViewModel | null = null;
	topHKStatistics: readonly TopHKViewObject[] = [];
	topVoterStatistics: TopVotersViewModel | null = null;
	onlineUsers: readonly IWebsiteClient[] = [];
	onlineVisitors: number = 0;
	memberCount: ISignalRMemberCounter | null = null;
	websiteVersion: string = '';

	@Mutation
	HandleUserStatisticsResponse(statistics: UserStatisticsViewModel) {
	    this.userStatistics = statistics;
	}

	@Action({ rawError: true })
	async GetUserStatistics() {
	    const result = await StatisticsApi.GetUserStatistics();
	    this.HandleUserStatisticsResponse(result);
	}

	@MutationAction({ mutate: ['topHKStatistics'], rawError: true })
	async GetTopHkPlayers(request: TopHKRequest) {
	    const result = await StatisticsApi.GetTopHkPlayers(request);
	    return { topHKStatistics: Object.freeze(result.topHKStatistics) };
	}

	@Mutation
	HandleUserTopVoterStatisticsResponse(result: TopVotersViewModel) {
	    this.topVoterStatistics = Object.freeze(result);
	}

	@Action({ rawError: true })
	async GetTopVoters() {
	    const result = await StatisticsApi.GetTopVoters();
	    this.HandleUserTopVoterStatisticsResponse(result);
	}

	@Mutation
	SetOnlineUsers(data: IOnlineUsersResponse) {
	    this.onlineUsers = Object.freeze(data.users);
	    this.onlineVisitors = Object.freeze(data.visitors);
	    this.memberCount = Object.freeze(data.memberCount);
	}

	@Mutation
	UpdateNewestUser(data: any) {
	    if (!this.userStatistics) return;

	    this.userStatistics.newestUser = Object.freeze(data.user);
	    this.userStatistics.totalUsers = Object.freeze(data.count);
	}

	@Mutation
	SetWebsiteVersion(version: string) {
	    this.websiteVersion = Object.freeze(version);
	}

	@Mutation
	Reset() {}

	@Action({ rawError: true })
	Clear() {
	    this.Reset();
	}

	@Action({ rawError: true })
	async Init() {
	    this.GetUserStatistics();
	}
}

const StatisticsModule = getModule(StatisticsState);

export { StatisticsModule };
